import Image from 'next/image';

import Video from 'react-scale/components/ui/video';
import useDeviceDetect from 'react-scale/hooks/useDeviceDetect';
import Tabs from 'react-scale/components/ui/tabs';

import Blurb from 'react-scale/components/ui/blurb';
import ExampleContent from './ExampleContent';
import s from './industries.module.css';

const Industries = ({
  tabs,
  landingHref,
  product,
  highlightedButton = false,
  buttonText,
  color,
  theme = 'light'
}) => {
  const { isMobile } = useDeviceDetect();

  const TabContent = ({ tab }) =>
    tab && (
      <>
        {tab.video && (
          <div className={s.fadeIn}>
            <Video
              className="mt-20 md:my-12 sm:mt-16 sm:mb-20 xl:mb-10"
              smallButton={isMobile}
              url={tab.video.src}
              poster={tab.video.poster}
              blackButton
            />
          </div>
        )}
        {tab.blurb && (
          <div className="xl:mb-20 mb-12 mt-12 xl:mt-28 xl:my-16">
            <Blurb title={tab.blurb.title} subtitle={tab.blurb.subtitle} icon={tab.blurb.icon} />
          </div>
        )}
        {tab.example && (
          <ExampleContent
            instruction={tab.example.instruction}
            code={tab.example.code}
            response={tab.example.response}
            example={tab.example.example}
            result={tab.example.result}
            responseDelay={tab.responseDelay || 1}
            landingHref={landingHref}
            highlightedButton={highlightedButton}
            buttonText={buttonText}
            product={product}
            color={color}
            theme={theme}
          />
        )}
        {tab.image && (
          <div className="mt-16">
            <Image
              layout="responsive"
              quality="100"
              loading="eager"
              priority
              src={tab.image}
              alt={tab.label}
              width={1139}
              height={703}
            />
          </div>
        )}
      </>
    );

  return (
    <Tabs
      tabs={[
        {
          content: <TabContent tab={tabs[0]} />,
          title: 'Logistics'
        },
        {
          content: <TabContent tab={tabs[1]} />,
          title: 'Financial Services'
        },
        {
          content: <TabContent tab={tabs[2]} />,
          title: 'Healthcare'
        }
      ]}
    />
  );
};

export default Industries;
